import { render, staticRenderFns } from "./PriceSurchargeModal.vue?vue&type=template&id=17f237ba&scoped=true"
import script from "./PriceSurchargeModal.vue?vue&type=script&lang=ts"
export * from "./PriceSurchargeModal.vue?vue&type=script&lang=ts"
import style0 from "./PriceSurchargeModal.vue?vue&type=style&index=0&id=17f237ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f237ba",
  null
  
)

export default component.exports